import { Component } from '@angular/core';
import { PayeePopupComponent } from '../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../shared/payee-buttons/payee-button/payee-button.component';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'app-restore-case-dialog',
  templateUrl: './restore-case-dialog.component.html',
  styleUrls: ['./restore-case-dialog.component.scss'],
  imports: [PayeePopupComponent, PayeeButtonComponent, MatDialogClose],
})
export class RestoreCaseDialogComponent {}
